import { createApp } from "vue";
import App from "./App.vue";
import "./style.css";
/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { VueQueryPlugin } from "@tanstack/vue-query";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import relativeTime from "dayjs/plugin/relativeTime";
import { createPinia } from "pinia";
import Vue3Toastify from "vue3-toastify";
import { router } from "./router/router";
import "./validation/rules";

dayjs.extend(relativeTime);
dayjs.locale("vi");

const pinia = createPinia();
const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(VueQueryPlugin);
app.use(Vue3Toastify, {
  clearOnUrlChange: false,
});
app.mount("#app");
